<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Wishlist" mainTitle="Wishlist" />
  <WishlistContent />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import WishlistContent from "../components/Wishlist/WishlistContent.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "WishlistPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    WishlistContent,
    DownloadTheApp,
    MainFooter,
  },
});
</script>